export var SMART_EVENT_TYPE = 'smart';
export var Actions = /*#__PURE__*/function (Actions) {
  Actions["REQUESTED"] = "requested";
  Actions["SUCCESSFUL"] = "successful";
  Actions["SEARCHED"] = "searched";
  Actions["FAILED"] = "failed";
  Actions["SELECTED"] = "selected";
  return Actions;
}({});
export var defaultAttributes = function defaultAttributes(context) {
  return {
    context: (context === null || context === void 0 ? void 0 : context.objectId) || '',
    sessionId: (context === null || context === void 0 ? void 0 : context.sessionId) || '',
    pickerType: 'mentions',
    source: 'smarts'
  };
};
export var getUsersForAnalytics = function getUsersForAnalytics(users) {
  return users ? users.map(function (_ref) {
    var id = _ref.id,
      entityType = _ref.entityType;
    return {
      id: id,
      type: entityType.toLowerCase()
    };
  }) : [];
};